'use strict';

/**
 * This module is generated by `gulp buildAssets`.
 */
export const SpriteSheet =
    /* <generated> */
{ font: [ [ 0, 0, 128, 512 ] ], uri: 'sprites.png' }
/* </generated> */
